import React, { useEffect, useState } from 'react';

import { useRESTDataCache, ResultProvider } from '../../dataProvider';
import { TYPES } from '../../envs';
import BarrasSimple from '../../components/pactometroCheck/barrasSimple';
import './sumaBloques.scss';

import { LOCALHOST, getSite } from '../../constants/sites';

import { useCurrentSite } from 'contexts';
import LoadingPlaceholder from 'components/loadingPlaceholder';

import { PROPERTIES_JSON, SUMA_BLOQUE_TITLE } from '../../core/constants';
import MasterBar from '../../components/cintillo/comunidad';

export default ({ match }) => {
  const params = useRESTDataCache(PROPERTIES_JSON(), 'GLOBAL_CONFIG', null);
  // const [selectedTarget, setSelectedTarget] = useState(null);
  const [selectedComponent, setSelectedComponent] = useState(null);
  // const [selectedIds, setSelectedIds] = useState([18, 25, 7]);
  const { year, type, electionNumber, placeId } = match.params;

  const { currentSite } = useCurrentSite();

  // Con esta funcion obtenemos ciertos valores pàra los partidos seleccionados y los que no.
  // Estos parametros son: text=(cadena a mostrar con todos los partidos separados por '+')
  //                      seats=(escaños totales de los partidos)
  //                      parties=(items de cada partido con todos los datos)
  useEffect(() => {
    if (params) {
      const site = getSite();
      const selectedC = params.sites[
        site !== LOCALHOST ? site : currentSite
      ].generator.tabs.find(c => c.component === 'MINI');
      setSelectedComponent(selectedC);
    }
  }, [params]);
  const getSeatsAndAcronyms = (data, selectedIds) => {
    const initialValue = {
      included: { text: '', seats: 0, parties: [] },
      excluded: { text: '', seats: 0, parties: [] }
    };
    if (data) {
      return data.reduce((acc, party) => {
        if (party.seats > 0) {
          // Seleccionamos el campo que vamos a modificar
          const field = selectedIds.includes(party.id)
            ? 'included'
            : 'excluded';
          // Acumulamos tanto texto como seats como los parties
          acc[field].text = acc[field].text.length
            ? `${acc[field].text} + ${party.partyAcronym}`
            : party.partyAcronym;
          acc[field].seats += party.seats;
          acc[field].parties = [...acc[field].parties, party];
        }
        return acc;
      }, initialValue);
    }
    return initialValue;
  };
  const site = getSite();

  if (!params || !selectedComponent || !selectedComponent.data) {
    return <LoadingPlaceholder />;
  }
  return (
    <div className="SCSumaBloquesDato">
      <ResultProvider
        active
        year={year}
        type={type}
        placeId={placeId}
        electionPlace={placeId}
        electionNumber={electionNumber}
        site={site}
      >
        {generalData => {
          if (!generalData || !generalData.partiesResult) {
            return <LoadingPlaceholder />;
          }
          return (
            <div className="SCSumaBloquesMain">
              <div className="SCSumaBloquesSection">
                <MasterBar
                  optionalTitleRegular={
                    SUMA_BLOQUE_TITLE[site !== LOCALHOST ? site : currentSite]
                  }
                  params={params}
                  match={match}
                />

                {selectedComponent.data.blocks.map(block => {
                  const { included, excluded } = getSeatsAndAcronyms(
                    generalData.partiesResult.sort(
                      (a, b) => a.votesPercent > b.votesPercent
                    ),
                    block.selecteds
                  );

                  const includedColor = included.parties.map(i => ({
                    ...i,
                    partyColor: block.right || i.partyColor
                  }));
                  const excludedColor = excluded.parties.map(i => ({
                    ...i,
                    partyColor: block.left || i.partyColor
                  }));

                  return (
                    <BarrasSimple
                      height={51}
                      data={[...excludedColor, ...includedColor]}
                      selecteds={
                        block.selecteds.length > 0
                          ? [
                              ...block.selecteds,
                              ...excluded.parties.map(e => e.id)
                            ]
                          : []
                      }
                      totalSeat={generalData.totalSeats}
                      centerProps={{ position: 'down', lineStyle: 'solid' }}
                      title={
                        block.selecteds.length > 0 && (
                          <div className="SCSumaBloquesDatos">
                            <div className="SCSumaBloquesDato">
                              <p className="big">
                                {excluded.seats}{' '}
                                <span title="Escaños">escaños</span>
                              </p>
                              <p>{block.excludeText || excluded.text}</p>
                            </div>
                            <div className="SCSumaBloquesDato right">
                              <p className="big">
                                {included.seats}{' '}
                                <span title="Escaños">escaños</span>
                              </p>
                              <p>{block.includeText || included.text}</p>
                            </div>{' '}
                          </div>
                        )
                      }
                    />
                  );
                })}
              </div>
            </div>
          );
        }}
      </ResultProvider>
    </div>
  );
};
